module.exports = __webpack_public_path__ + "static/img/AgAABXq0GNfIZ81YVcRNl6IWIx14hCPl.fc0111a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/套装/AgAABXq0GNfIZ81YVcRNl6IWIx14hCPl.jpeg
// module id = xxWG
// module chunks = 0